/*!

=========================================================
* Vue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import App from './App.vue'
import router from './routes/router'
import './registerServiceWorker'
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import ArgonDashboard from './plugins/argon-dashboard'
import '@aws-amplify/ui-vue';
import Amplify, { Auth, Logger, Hub } from 'aws-amplify'
import aws_exports from './aws-exports'
import Axios from 'axios'
import VueAxios from 'vue-axios'
import BootstrapVue from 'bootstrap-vue'


Axios.defaults.baseURL = 'https://pharmaapi.carepointrx.com/api/'
//Axios.defaults.baseURL = 'https://localhost:5001/api/'

Axios.interceptors.request.use(async config => {
    //console.log("interceptor", JSON.stringify(config));
    //console.log(JSON.stringify(Axios.defaults));
    let jwtToken = await Amplify.Auth.currentSession().then(data => {
        Vue.prototype.$jwtToken = data.idToken.jwtToken;
        Axios.defaults.headers.common['Authorization'] = `Bearer ${Vue.prototype.$jwtToken}`;
        return data.idToken.jwtToken;
    });
    config.headers.common['Authorization'] = `Bearer ${jwtToken}`;
    //console.log("after auth", JSON.stringify(config));
    //console.log(JSON.stringify(Axios.defaults));
    return config;
});

Amplify.configure(aws_exports);

Vue.config.productionTip = false
Vue.component('v-select', vSelect)
Vue.use(VueAxios, Axios);

Vue.prototype.$Amplify = Amplify;
Vue.prototype.$jwtToken = "";


Vue.use(Auth, Logger);
Vue.use(Amplify);

Vue.use(BootstrapVue);
Vue.use(ArgonDashboard);




Hub.listen('auth', (data) => {
    if (data.payload.event == "signOut") {
        router.push("/login");
    }
    if (data.payload.event == "signIn") {
        Vue.prototype.$jwtToken = data.payload.data.signInUserSession.idToken.jwtToken;
        Vue.prototype.$userName = data.payload.data.attributes.name;
        Axios.defaults.headers.common['Authorization'] = `Bearer ${Vue.prototype.$jwtToken}`;
        if (router.currentRoute.query.redirect) {
            router.push(router.currentRoute.query.redirect);
        } else {
            router.push("/dashboard");
        }
    }
})

new Vue({
  router,
    render: h => h(App),
    created() {
        
    }
}).$mount('#app')
